import { memo } from "react";

import TableSimple from "ds/components/TableSimple";
import { Repo } from "types/generated";
import useAllItemsCount from "shared/SpaceliftVcsRepo/useSearchSpaceliftVcsReposSuggestions/useAllItemsCount";
import TablePagination from "components/Table/Pagination";
import useSpaceliftVcsReposStore from "shared/SpaceliftVcsRepo/useSpaceliftVcsReposList/store";
import usePagination from "components/Table/Pagination/usePagination";

import useSpaceliftVcsReposTableStore from "./useSpaceliftVcsReposTableStore";
import { SPACELIFT_VCS_REPOS_TABLE_CELLS } from "./Cells";
import {
  SPACELIFT_VCS_REPOS_LIMIT,
  SPACELIFT_VCS_REPOS_LIMIT_STORAGE_KEY,
  SPACELIFT_VCS_REPOS_PAGINATION_OPTIONS,
  SPACELIFT_VCS_REPOS_SORT_CONFIG,
  SPACELIFT_VCS_REPOS_SORT_STORAGE_KEY,
} from "./constants";

type SpaceliftVcsReposTableProps = {
  repos: Repo[];
  loading: boolean;
  startCursor: string | undefined;
  endCursor: string | undefined;
  resetKey?: unknown;
};

const SpaceliftVcsReposTable = ({
  repos,
  loading,
  startCursor,
  endCursor,
  resetKey,
}: SpaceliftVcsReposTableProps) => {
  const { allItemsCount } = useAllItemsCount();
  const { onFetchItems } = useSpaceliftVcsReposStore();

  const {
    rowsPerPage,
    setRowsPerPage,
    from,
    to,
    lastPage,
    page,
    goToNextPage,
    goToPrevPage,
    goToFirstPage,
    goToLastPage,
  } = usePagination({
    fetchItems: onFetchItems,
    startCursor,
    endCursor,
    allItemsCount,
    visibleItemsCount: repos.length,
    initialLimit: SPACELIFT_VCS_REPOS_LIMIT,
    storageKey: SPACELIFT_VCS_REPOS_LIMIT_STORAGE_KEY,
    resetKey,
    loading,
  });

  return (
    <>
      <TableSimple
        data={repos}
        loading={loading}
        store={useSpaceliftVcsReposTableStore}
        ariaLabel="Repos table"
        cellPerColumn={SPACELIFT_VCS_REPOS_TABLE_CELLS}
        filtersStorageKey={SPACELIFT_VCS_REPOS_SORT_STORAGE_KEY}
        sortConfig={SPACELIFT_VCS_REPOS_SORT_CONFIG}
      />

      <TablePagination
        from={from}
        to={to}
        loading={loading}
        goToNextPage={goToNextPage}
        setRowsPerPage={setRowsPerPage}
        goToPrevPage={goToPrevPage}
        goToFirstPage={goToFirstPage}
        goToLastPage={goToLastPage}
        rowsPerPage={rowsPerPage}
        itemsCount={allItemsCount}
        lastPage={lastPage}
        page={page}
        paginationOptions={SPACELIFT_VCS_REPOS_PAGINATION_OPTIONS}
      />
    </>
  );
};

export default memo(SpaceliftVcsReposTable);
